import { buildWebStorage, setupCache } from 'axios-cache-interceptor'
import { DEV } from 'js/utils/constants/app'
import { lang } from 'store/lang.store'
import { useDevTricks } from 'composables/useDevTricks'
import axios from 'axios'

const csrf = window.context.csrf
const { config: devConfig } = useDevTricks()

const API_HEADER = {
  post: { 'X-CSRFTOKEN': csrf },
  'X-CSRFToken': csrf,
  'Accept-Language': lang.value,
}

const api = setupCache(
  axios.create({
    baseURL: '/',
    withCredentials: true,
    headers: API_HEADER,
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFTOKEN',
  }),
  {
    ...(DEV && devConfig.value.cache.persistent
      ? { storage: buildWebStorage(localStorage, 'axios-cache:') }
      : {}),
  }
)

const URLS = {
  users: '/api/users/',
  pergunta: '/api/pergunta/',
  profile: '/api/profile/',
  assessment: '/api/assessment/',
  item_respostas: '/api/item-resposta/',
  item_respostas_button: '/api/item-resposta/simple_create/',
  item_respostas_livre: '/api/item-resposta/free_create/',
  evidencia: '/api/evidencia/',
  evidencia_file: '/api/evidencia_file/',
  plano_acao: '/api/plano-acao/',
  acompanhamento: '/api/acompanhamento-contato/',
  evidencia_muda_status: '/api/evidencia/muda_status/',
  agrupamento_envio: '/api/agrupamento-envio/',
}

api.interceptors.request.use(
  function requestMethod(config) {
    if (config.method !== 'get') {
      if (!devConfig.value.cache.clearOnMutation && DEV) return
      api?.storage?.clear()
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

export { api, URLS, API_HEADER }

// export default function ({ csrf }) {
// 	axios.defaults.xsrfCookieName = 'csrftoken'
// 	axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"
// 	axios.defaults.headers.post['X-CSRFTOKEN'] = csrf;
//   axios.defaults.baseURL =

// }
